import request from '@/utils/request';

/**
 * 获取注册活动分页列表
 * @param {*} params { page: 1, size: 10 }
 */
export function getRegistrationPage(params) {
    return request({
        url: '/biz/users/registration/page',
        method: 'get',
        params,
    });
}


// 编辑注册活动项
export function editRegistration(data) {
    return request({
        url: '/biz/users/registration/edit',
        method: 'post',
        data,
    });
}
